const FINANCE_COLORS: Record<string, string> = {
  not_set: 'zinc',
  stage_zero: 'sky',
  stage_one: 'indigo',
  stage_two: 'violet',
  stage_three: 'amber',
  stage_four: 'emerald',
  stage_five: 'green',
}

export function getFinanceStageColor(stage: string): string {
  return FINANCE_COLORS[stage] || 'zinc'
}

export function getFinanceStageLabel(stage: string): string {
  return stage.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}
